import React from 'react';
import Blogs from '../components/Blogs';

const BlogsPage = () => {
  return (
    <div style={{ paddingTop: '80px' }}>
      <Blogs />
    </div>
  );
};

export default BlogsPage;
